import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {NotificationSubscription} from '../types';

interface IndexPageHeaderProps {
    selectedRecords: NotificationSubscription[];
    setSelectedRecords: (records: NotificationSubscription[]) => void;
}

const useTools = (selectedRecords: NotificationSubscription[], setSelectedRecords: (records: NotificationSubscription[]) => void) => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes('DeleteNotificationSubscription')) {
        tools.push(<DeleteRecordButton key='delete' selectedRecords={selectedRecords}
                                       setSelectedRecords={setSelectedRecords}/>);
    }

    if (allowedActions.includes('CreateNotificationSubscription')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = ({selectedRecords, setSelectedRecords}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Notification Subscriptions')}
            tools={useTools(selectedRecords, setSelectedRecords)}
        />
    );
};
